export const INIT_PAGE = 1;

export const LEAD_MANAGEMENT_PAGES = 10;

export const ALLSTOREID = 'AllStores';
